import { render, staticRenderFns } from "./FinalDonorList.vue?vue&type=template&id=0e60dfd2"
import script from "./FinalDonorList.vue?vue&type=script&lang=js"
export * from "./FinalDonorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports